import { CHECKOUT } from '../services/constants';

export default {
    go,
}

function go(stage: string, direction = 1) {
    if (direction == -1) {
        if (stage == CHECKOUT.HOME) {
            return CHECKOUT.CLOSE;
        } else if (stage == CHECKOUT.SUGGESTIONS) {
            return CHECKOUT.CLOSE;
        } else if (stage == CHECKOUT.CHOOSE_SHOP) {
            return CHECKOUT.HOME;
        } else if (stage == CHECKOUT.DELIVERY_DATE) {
            return CHECKOUT.HOME;
        } else if (stage == CHECKOUT.DELIVERY_ADDRESS) {
            return CHECKOUT.HOME;
        } else if (stage == CHECKOUT.CHOOSE_CONFIRM_METHOD) {
            return CHECKOUT.HOME;
        } else if (stage == CHECKOUT.EDIT_ADDRESS) {
            return CHECKOUT.HOME;
        }
    }
    if (direction == 1) {
        if (stage == CHECKOUT.BEFORE_START) {
            return CHECKOUT.SUGGESTIONS;
        } else if (stage == CHECKOUT.SUGGESTIONS) {
            return CHECKOUT.HOME;
        } else if (stage == CHECKOUT.HOME) {
            return CHECKOUT.CHOOSE_CONFIRM_METHOD;
        } else if (stage == CHECKOUT.DELIVERY_DATE) {
            return CHECKOUT.HOME;
        } else if (stage == CHECKOUT.CHOOSE_SHOP) {
            return CHECKOUT.HOME;
        } else if (stage == CHECKOUT.DELIVERY_ADDRESS) {
            return CHECKOUT.HOME;
        } else if (stage == CHECKOUT.EDIT_ADDRESS) {
            return CHECKOUT.HOME;
        }
    }
    console.error('Not defined where to go(',direction,') from ',stage);
}